import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler, CRow } from '@coreui/react'
import CIcon from '@coreui/icons-react'

import AppSidebarNav from './AppSidebarNav'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

// sidebar nav config
import navigation from '../_nav'

const AppSidebar = (props) => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((props) => props.state.sidebarUnfoldable)
  const sidebarShow = useSelector((props) => props.state.sidebarShow)
  const {user} = useSelector((props) => props.account);

  const menu = navigation();

  return (
    <CSidebar id={"leftside"}
              className={"hidden-print"}
      position="fixed"
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarBrand className="p-3 d-none d-md-flex" to="/">
        <center>
          <CRow>
            <h4 className="text-white">{user ? user.userNm : ""} 님</h4>
            <h6 className="text-danger">online</h6>
          </CRow>
        </center>
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav items={menu} setSelectedMenu={props.setSelectedMenu} />
        </SimpleBar>
      </CSidebarNav>
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
